import { render } from "./UserManagementDeleteUserDialog.vue?vue&type=template&id=4b40687b"
import script from "./UserManagementDeleteUserDialog.vue?vue&type=script&lang=js"
export * from "./UserManagementDeleteUserDialog.vue?vue&type=script&lang=js"

import "./UserManagementDeleteUserDialog.vue?vue&type=style&index=0&id=4b40687b&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
